"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 接口省市区模块
var _default = exports.default = {
  getpProvincesList: function getpProvincesList(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/region/list',
      method: 'post',
      data: data
    });
  }
};